import * as actions from './portfolioProject.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { PortfolioProjectModel } from '@smarttask-common/src/lib/models/Portfolio/Project/PortfolioProjectModel';

export const projectAdapter = createEntityAdapter<PortfolioProjectModel>({
    selectId: (x) => x.project.project_id,
});
export interface PortfolioProjectState extends EntityState<PortfolioProjectModel> {
    selected_project_id: string;
}

export const initialState: PortfolioProjectState = projectAdapter.getInitialState({
    selected_project_id: undefined,
});

export function PortfolioProjectReducers(
    state: PortfolioProjectState = initialState,
    action: actions.PortfolioProjectActions
) {
    switch (action.type) {
        case actions.PortfolioProjectActionTypes.UPDATE_SELECTED_ID:
            state = { ...state, selected_project_id: action.selected_project_id };
            return state;

        case actions.PortfolioProjectActionTypes.ADD_PORTFOLIO_PROJECT:
            return projectAdapter.addOne(action.portfolio_project, state);

        case actions.PortfolioProjectActionTypes.ADD_PORTFOLIO_PROJECTS:
            return projectAdapter.addMany(action.portfolio_projects, state);

        case actions.PortfolioProjectActionTypes.UPSERT_PORTFOLIO_PROJECT:
            return projectAdapter.upsertOne(action.portfolio_project, state);

        case actions.PortfolioProjectActionTypes.UPSERT_PORTFOLIO_PROJECTS:
            return projectAdapter.upsertMany(action.portfolio_projects, state);

        case actions.PortfolioProjectActionTypes.UPDATE_PORTFOLIO_PROJECT:
            return projectAdapter.updateOne(action.portfolio_project, state);

        case actions.PortfolioProjectActionTypes.UPDATE_PORTFOLIO_PROJECTS:
            return projectAdapter.updateMany(action.portfolio_projects, state);

        case actions.PortfolioProjectActionTypes.DELETE_PORTFOLIO_PROJECT:
            if(state.selected_project_id == action.id){
              state.selected_project_id = undefined;
            }
            return projectAdapter.removeOne(action.id, state);

        case actions.PortfolioProjectActionTypes.DELETE_PORTFOLIO_PROJECTS:
            if(action.ids.indexOf(state.selected_project_id) > -1){
              state.selected_project_id = undefined;
            }
            return projectAdapter.removeMany(action.ids, state);

        case actions.PortfolioProjectActionTypes.DELETE_ALL_PORTFOLIO_PROJECTS:
            return projectAdapter.removeMany(action.ids, state);

        case actions.PortfolioProjectActionTypes.DELETE_ALL:
            return projectAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getPortfolioProjectState = createFeatureSelector<PortfolioProjectState>('portfolioProject');

export const { selectIds, selectEntities, selectAll, selectTotal } =
    projectAdapter.getSelectors(getPortfolioProjectState);

const getSelectedProjectIdState = (state: PortfolioProjectState) => {
    return state.selected_project_id;
};
export const getSelectedProjectId = createSelector(getPortfolioProjectState, getSelectedProjectIdState);

export const getSelectedProject = createSelector(getPortfolioProjectState, (state: PortfolioProjectState) => {
    if (state.selected_project_id == undefined) {
        return undefined;
    }
    return state.entities[state.selected_project_id];
});
